module.exports = __webpack_public_path__ + "assets/img/22-l.7cb1885.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/photo/objects/22-l.jpg
// module id = h8gT
// module chunks = 0